module.exports = __webpack_public_path__ + "img/playbutton13.a8056807.png";